import { render } from "./indicator.vue?vue&type=template&id=184d4cd8"
import script from "./indicator.vue?vue&type=script&lang=js"
export * from "./indicator.vue?vue&type=script&lang=js"

import exportComponent from "/var/deploy/beta/web_head/releases/20260320221641/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__